import { useStoreActions } from '@/stores/store';
import { Platform } from 'react-native';
import constants, { isPatientApp } from '@/config/constants';
import Constants from 'expo-constants';

interface UseResultBufferSettings {
  setItemType: string;
  setItemTypeId: string;
  exerciseType: unknown;
  patientId: string;
  shouldTracksMistakes: boolean;
  selectedPerformance?: string;
  detailedPerformance?: boolean;
  isSelf: boolean;
}

interface TrackResultPayload {
  mistakes: number;
  setItemType: string;
  setItemTypeId: string;
  exerciseType: unknown;
  shouldTracksMistakes: boolean;
}

const generateTrackResult = (payload: TrackResultPayload) => {
  const app = isPatientApp ? 'patient' : 'therapist';
  const appVersion = constants.appVersion;
  const {
    mistakes,
    setItemType,
    setItemTypeId,
    exerciseType,
    shouldTracksMistakes,
  } = payload;

  const consistentKeys = {
    os: Platform.OS === 'web' ? 'browser' : Platform.OS,
    app,
    appVersion,
    exerciseType,
    realUuid: '',
    uuid: 0,
    [setItemType]: setItemTypeId,
    performance: '',
  };

  return {
    ...consistentKeys,
    ...(shouldTracksMistakes && { mistakes }),
    isEigentraining: false,
  };
};

export function useResultBuffer({
  setItemType,
  setItemTypeId,
  exerciseType,
  patientId,
  shouldTracksMistakes,
  selectedPerformance,
  detailedPerformance,
  isSelf,
}: UseResultBufferSettings) {
  const storeTherapistBuffer = useStoreActions(
    (actions) => actions.storeTherapistBuffer,
  );

  const resultCreator = function (
    mistakes: number,
    injectedPerformance?: string,
  ) {
    const result = generateTrackResult({
      mistakes,
      setItemType,
      setItemTypeId,
      exerciseType,
      shouldTracksMistakes,
    });
    if (!selectedPerformance) {
      let performance;
      if (detailedPerformance) {
        if (mistakes == 0) {
          performance = 'Richtig';
        } else if (mistakes < 2) {
          performance = 'Fast';
        } else {
          performance = 'Falsch';
        }
      } else {
        if (mistakes == 0) {
          performance = 'Richtig';
        } else {
          performance = 'Falsch';
        }
      }
      result.performance = performance;
    } else {
      result.performance = injectedPerformance || selectedPerformance;
    }
    const dateObject = new Date();
    const timezoneOffset = dateObject.getTimezoneOffset() * 60000;
    const uuid = dateObject.valueOf() - timezoneOffset;

    if (isSelf && !isPatientApp) {
      result.isEigentraining = true;
    }

    result.uuid = uuid;
    result.realUuid = Constants.sessionId + '_' + uuid;

    storeTherapistBuffer({
      patientId,
      result,
    });
  };

  return {
    resultCreator,
  };
}
